RivalIQ.apps.CompanyProfile.module('curations.filters', function (filters, App, Backbone, Marionette, $, _) {

    'use strict';

    filters.loadCompanies = function (curation) {
        curation.companies = RivalIQ.state.landscape.get('companies');
        curation.company = curation.companies.get(curation.getProp('companyId'));

        // if the target company doesnt exist (we switched landscape), use the first company
        if (!curation.company) {
            curation.company = curation.companies.first();
            curation.setProps({
                companyId: curation.company.id
            });
        }
    };

});
